class StationCoverageZone {
  constructor(title, fenceColor, stationId, stationCoverageZoneFences) {
    this.title = title;
    this.fenceColor = fenceColor;
    this.stationId = stationId;
    this.stationCoverageZoneFences = stationCoverageZoneFences;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allStationCoverageZones: [],
      stationCoverageZone: new StationCoverageZone('', '', null, []),
      allStationCoverageZonesForOther: [],
      allStationCoverageZonesForFence: [],
    };
  },
  methods: {
    getListOfStationCoverageZones: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStationCoverageZones').then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.allStationCoverageZonesForOther =
            this.$store.state.stationCoverageZoneModule.allStationCoverageZones;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfStationCoverageZones();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfStationCoverageZones();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllStationCoverageZones: function (stationId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStationCoverageZones', stationId).then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.allStationCoverageZones =
            this.$store.state.stationCoverageZoneModule.allStationCoverageZones;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllStationCoverageZones(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllStationCoverageZones(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllStationCoverageZonesForAllStations: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStationCoverageZonesWithOutId').then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.allStationCoverageZonesForFence =
            this.$store.state.stationCoverageZoneModule.allStationCoverageZonesOfAllStations;
          if (this.$route.name == 'dispatchMap' || this.$route.name == 'newMissionWithMap800' ||
            this.$route.name == 'followUpMap' || this.$route.name == 'admissionMap' || this.$route.name == 'eocMap') {

            this.readyFencesForMap(this.allStationCoverageZonesForFence);
          }
          if (this.sendTOPhoneModal) {
            this.readyFencesFor800Map(this.allStationCoverageZonesForFence);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllStationCoverageZonesForAllStations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllStationCoverageZonesForAllStations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addStationCoverageZoneFunction: function () {
      if (!this.stationCoverageZone.title) {
        this.snackText = 'عنوان فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.stationCoverageZone.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.colorValue) {
        this.snackText = 'رنگ فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.addFanceCordsLatLng.length == 0) {
        this.snackText = 'فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let temp = this.addFanceCordsLatLng[0];
      if (temp) {
        if (temp.length == 0) {
          this.snackText = 'فنس منطقه نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
        if (temp.length < 3) {
          this.snackText = 'فنس منطقه نامعتبر است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.stationCoverageZone.fenceColor = this.colorValue;
      for (let i = 0; i < temp.length; i++) {
        this.stationCoverageZone.stationCoverageZoneFences.push({
          pointNumber: i + 1,
          latitude: temp[i].lat,
          longitude: temp[i].lng,
        });
      }
      this.$store.dispatch('addStationCoverageZone', this.stationCoverageZone).then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.fenceModal = false;
          this.snackText = ' فنس منطقه با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          const map = this.$refs.fancemap.mapObject;
          //map.removeLayer(this.polygon);
          for (let i in map._layers) {
            if (map._layers[i]._path != undefined) {
              try {
                map.removeLayer(map._layers[i]);
              } catch (e) {
                this.snackText = e;
                this.$refs.snackRef.snackModel = true;
                this.snackColor = '#FF5252';
                this.snakIcon = 'mdi-information';
              }
            }
          }
          this.colorValue = '#1976D2FF';
          this.stationCoverageZone = new StationCoverageZone('', '', this.stationId, []);
          this.hasOtherFence = false;
          this.addFlag = true;
          this.stationHasFance = false;
          this.toggleEditFlag = false;
          this.getAllStationCoverageZones(this.stationId);
          this.getAllStationCoverageZonesForAllStations();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getStationCoverageZoneFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getStationCoverageZone', id).then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.fenceModal = true;
          this.stationCoverageZone =
            this.$store.state.stationCoverageZoneModule.stationCoverageZone;
          this.stationCoverageZone.stationId = Number(this.stationId);
          this.colorValue = this.stationCoverageZone.fenceColor;
          this.currentFenceCoords = [];
          this.currentFenceColor = this.colorValue;
          this.addFanceCordsLatLng = [];
          for (let i = 0; i < this.stationCoverageZone.stationCoverageZoneFences.length; i++) {
            delete this.stationCoverageZone.stationCoverageZoneFences[i].id;
            let data = [];
            data.push(this.stationCoverageZone.stationCoverageZoneFences[i].latitude);
            data.push(this.stationCoverageZone.stationCoverageZoneFences[i].longitude);
            this.currentFenceCoords.push(data);
          }
          this.addFanceCordsLatLng[0] = this.currentFenceCoords;
          this.showEditModal(this.stationCoverageZone);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getStationCoverageZoneFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getStationCoverageZoneFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editStationCoverageZoneFunction: function () {
      if (!this.stationCoverageZone.title) {
        this.snackText = 'عنوان فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.stationCoverageZone.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.colorValue) {
        this.snackText = 'رنگ فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.addFanceCordsLatLng.length == 0) {
        this.snackText = 'فنس منطقه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let temp = this.addFanceCordsLatLng[0];
      if (temp) {
        if (temp.length == 0) {
          this.snackText = 'فنس منطقه نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
        if (temp.length < 3) {
          this.snackText = 'فنس منطقه نامعتبر است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.stationCoverageZone.stationCoverageZoneFences = [];
      this.stationCoverageZone.fenceColor = this.colorValue;
      for (let i = 0; i < temp.length; i++) {
        let lat = null;
        let lng = null;
        if (temp[i].length && temp[i].length > 1) {
          lat = temp[i][0];
          lng = temp[i][1];
        } else {
          if (temp[i].lat) {
            lat = temp[i].lat;
          } else {
            lat = temp[i];
          }
          if (temp[i].lng) {
            lng = temp[i].lng;
          } else {
            lng = temp[i];
          }
        }
        this.stationCoverageZone.stationCoverageZoneFences.push({
          pointNumber: i + 1,
          latitude: lat,
          longitude: lng,
        });
      }
      this.$store.dispatch('editStationCoverageZone', this.stationCoverageZone).then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.fenceModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' فنس منطقه با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';

          const map = this.$refs.fancemap.mapObject;
          //map.removeLayer(this.polygon);
          for (let i in map._layers) {
            if (map._layers[i]._path != undefined) {
              try {
                map.removeLayer(map._layers[i]);
              } catch (e) {
                this.snackText = e;
                this.$refs.snackRef.snackModel = true;
                this.snackColor = '#FF5252';
                this.snakIcon = 'mdi-information';
              }
            }
          }
          this.colorValue = '#1976D2FF';
          this.stationCoverageZone = new StationCoverageZone('', '', this.stationId, []);
          this.hasOtherFence = false;
          this.addFlag = true;
          this.stationHasFance = false;
          this.toggleEditFlag = false;
          this.getAllStationCoverageZones(this.stationId);
          this.getAllStationCoverageZonesForAllStations();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteStationCoverageZoneFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteStationCoverageZone', this.stationCoverageZoneId).then(() => {
        if (this.$store.state.stationCoverageZoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllStationCoverageZones(this.stationId);
          this.getAllStationCoverageZonesForAllStations();
          this.snackText = ' فنس منطقه با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationCoverageZoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationCoverageZoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteStationCoverageZoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.stationCoverageZoneModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
